/* ProviderIconView.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._00EA0egIor%7B-o-object-fit%3Acontain%3Bobject-fit%3Acontain%7D");
import React from 'react';
import type { ProviderIcon } from './useSmartLinkMetadata';
const providerIconImageStyles = null;

/**
 * Renders a provider icon, accepting either a ready-to-render React node
 * (e.g. the Confluence/Jira logo elements returned by `extractSmartLinkProvider`)
 * or a remote image URL (e.g. a third-party provider PNG).
 */
export const ProviderIconView = ({
  icon
}: {
  icon: ProviderIcon | undefined;
}): React.JSX.Element | null => {
  if (!icon) {
    return null;
  }
  if (icon.kind === 'url') {
    return <img src={icon.url} alt="" className={ax(["_3iDTPbvbI6 _39xV02ey7F _0jFU0Vey7F _00EA0egIor"])} />;
  }
  return <React.Fragment>{icon.node}</React.Fragment>;
};